import { PageLoading } from "../../../components/page_loading";
import Grid from "@mui/joy/Grid";
import Typography from "@mui/joy/Typography";

export const UtilitiesComponent = (props: {
  loading: boolean;
  deploymentId: string;
  utilitiesStackStatus: string | null;
}) => {
  const { loading, utilitiesStackStatus } = props;

  return (
    <>
      <PageLoading loading={loading} />
      <Grid container spacing={2} sx={{ flexGrow: 1 }}>
        <Grid xs={12}>
          <Typography level="body-sm" sx={{ py: 1 }}>
            CloudFormation stack status:{" "}
            {utilitiesStackStatus || "Not deployed"}
          </Typography>
        </Grid>
      </Grid>
    </>
  );
};
